import classNames from 'classnames';
import IconComponent from 'components/common/IconComponent';
import useWindowSize from 'hooks/useWindowSize';
import React from 'react';

import { ISlideInProps } from './types';

const SlideIn: React.FC<ISlideInProps> = ({
  onClose,
  children,
  mobileThreshold,
  title,
  className,
  style,
  borderedTitle,
}) => {
  const windowWidth = useWindowSize().width;
  const isMobile = !!mobileThreshold && mobileThreshold <= windowWidth;
  const containerClassNames = classNames(`${className} slide-in-container`, {
    // visible,
    mobile: isMobile,
  });
  return (
    <div className={containerClassNames} style={style}>
      <div className='side-close-button'>
        <button type='button' onClick={onClose}>
          <IconComponent name='close' size={30} />
        </button>
      </div>
      <div className='slide-in-title' style={{ borderBottom: borderedTitle ? '1px solid #dedede' : undefined }}>
        {title}
      </div>
      <div className='slide-in-content'>{children}</div>
    </div>
  );
};

export default React.memo(SlideIn);
